import { render } from "./RuiLogout.vue?vue&type=template&id=e06b2914"
const script = {}
script.render = render

export default script